import React from 'react'
import PropTypes from 'prop-types'
import {Container, Row, Col} from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import Text from '../../../components/ui/text'
import {IntroBlocksWrap, Box} from './intro-blocks.style'

const IntroBlocks = ({problemStyle, titleStyle, descStyle, linkStyle}) => {
  return (
    <IntroBlocksWrap>
      <Container>
        <Row>
          <Col lg={6}>
            <Box>
              <Heading {...problemStyle}>
                Small business owners work hard without seeing real growth.
                They feel isolated and less certain to make the right calls
                whether it be about <b>capital</b>, planning for <b>growth</b>,
                or becoming more competitive
              </Heading>
            </Box>
          </Col>
          <Col lg={6}>
            <Box>
              <Heading {...titleStyle}>
                The right support makes all the difference
              </Heading>
              <Text {...descStyle}>
                <em>Our team is ready to engage with you where you need it most</em>
              </Text>
              <Text {...linkStyle}>
                Plug into <b>our ongoing support network</b>
              </Text>
            </Box>
          </Col>
        </Row>
      </Container>
    </IntroBlocksWrap>
  );
};

IntroBlocks.propTypes = {
  problemStyle: PropTypes.object,
  titleStyle: PropTypes.object,
  descStyle: PropTypes.object,
  linkStyle: PropTypes.object,
};

IntroBlocks.defaultProps = {
  problemStyle: {
    as: 'h5',
    color: '#086AD8',
    fontweight: 600,
    lineHeight: 1.5,
    mb: '0',
  },
  titleStyle: {
    as: 'h5',
    color: '#086AD8',
    fontweight: 700,
    mb: '20px',
  },
  descStyle: {
    color: '#333333',
    fontweight: 600,
    mb: '20px',
  },
  linkStyle: {
    color: '#086AD8',
    fontweight: 600,
    mb: '0',
  },
};

export default IntroBlocks;
